import React from 'react'
import { Check } from 'lucide-react'
import styles from './CheckItem.module.scss'

export const CheckItem: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={styles.item}>
    <span className={styles.icon} aria-hidden="true">
      <Check size={12} strokeWidth={3} />
    </span>
    <span className={styles.label}>{children}</span>
  </div>
)
